import { Fragment } from "react";

//@ts-ignore
import { tw } from "@careinfo/tailwind";
import { Popover, Transition } from "@headlessui/react";
import { Download, Edit, Trash } from "lucide-react";

const FileOptions = ({
  setOpenRenameFolderPopup,
  setSelected,
  file,
  handleDelete,
  isdeleteLoading,
}) => {
  const handleDownload = async () => {
    try {
      const response = await fetch(file?.file);
      if (!response.ok) throw new Error("Failed to download file");

      const blob = await response.blob();
      const url = window.URL.createObjectURL(blob);

      const a = document.createElement("a");
      a.href = url;
      a.download = file?.title || "download";
      document.body.appendChild(a);
      a.click();
      a.remove();
      window.URL.revokeObjectURL(url);
    } catch (error) {
      console.error("Download error:", error);
    }
  };

  return (
    <div className={tw``}>
      <Popover className={tw`relative`}>
        {({ open }) => (
          <>
            <Popover.Button className={tw`  focus:outline-none `}>
              <svg
                width="20px"
                height="20px"
                viewBox="0 0 16 16"
                xmlns="http://www.w3.org/2000/svg"
                fill="currentColor"
              >
                <g id="SVGRepo_bgCarrier" stroke-width="0"></g>
                <g
                  id="SVGRepo_tracerCarrier"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                ></g>
                <g id="SVGRepo_iconCarrier">
                  <path d="M9.5 13a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0zm0-5a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0zm0-5a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0z"></path>{" "}
                </g>
              </svg>
            </Popover.Button>
            <Transition
              as={Fragment}
              enter={tw`transition ease-out duration-200`}
              enterFrom={tw`opacity-0 translate-y-1`}
              enterTo={tw`opacity-100 translate-y-0`}
              leave={tw`transition ease-in duration-150`}
              leaveFrom={tw`opacity-100 translate-y-0`}
              leaveTo={tw`opacity-0 translate-y-1`}
            >
              <Popover.Panel
                className={tw`absolute z-10 mt-6  max-w-sm w-60 px-4 -mx-[20px]`}
                style={{
                  maxHeight: "calc(100vh - 20px)",
                  overflowY: "auto",
                  right: 0,
                  left: "auto",
                }}
              >
                <div className={tw`w-52 shadow-lg  bg-white  py-2 rounded`}>
                  <ul>
                    <li>
                      <button
                        type="button"
                        onClick={() => {
                          setOpenRenameFolderPopup(true);
                          setSelected({ id: file?.id, title: file?.title });
                        }}
                        className={tw`flex gap-x-2 items-center w-full px-4 py-1 focus:outline-none rounded hover:bg-gray-300 `}
                      >
                        <Edit />
                        Rename
                      </button>
                    </li>
                    <li>
                      <button
                        type="button"
                        onClick={(e) => {
                          e.stopPropagation(), handleDownload();
                        }}
                        className={tw`flex gap-x-2 items-center w-full px-4 py-1 focus:outline-none rounded hover:bg-gray-300`}
                      >
                        <Download />
                        Download
                      </button>
                    </li>
                    <li>
                      <button
                        type="button"
                        disabled={isdeleteLoading || false}
                        onClick={(e) => {
                          e.stopPropagation(), handleDelete(file?.id);
                        }}
                        className={tw`flex gap-x-2 items-center w-full px-4 py-1 focus:outline-none rounded hover:bg-gray-300 `}
                      >
                        <Trash />
                        Delete
                      </button>
                    </li>
                  </ul>
                </div>
              </Popover.Panel>
            </Transition>
          </>
        )}
      </Popover>
    </div>
  );
};

export default FileOptions;
